import { Client } from "@portal/lib/query/query";
export const queryClient = new Client({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
